import { useState } from "react";
import { Copy, Check, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReportErrorDialog } from "./ReportErrorDialog";
import { toast } from "@/hooks/use-toast";

type Props = {
  code: string;
  hint?: string;
  className?: string;
};

export function ErrorCodeDisplay({ code, hint, className }: Props) {
  const [copied, setCopied] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      toast({ title: "Code copié", description: code });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast({ title: "Impossible de copier", variant: "destructive" });
    }
  };

  return (
    <div className={`rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm ${className ?? ""}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-medium text-destructive">Code d'erreur :</span>
        <code className="font-mono text-xs bg-background px-2 py-1 rounded border">{code}</code>
        <Button size="sm" variant="ghost" className="h-7 px-2" onClick={handleCopy}>
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
        </Button>
        <Button size="sm" variant="outline" className="h-7 ml-auto" onClick={() => setDialogOpen(true)}>
          <Send className="h-3.5 w-3.5 mr-1" />
          Signaler à l'admin
        </Button>
      </div>
      {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
      <ReportErrorDialog code={code} open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}
